import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  font-family: ${theme.font.poppins};
`;

export const TitleEl = styled.h2`
  font-size: 18px;
  font-style: normal;
  font-weight: ${theme.font.bold};
  line-height: 150%;
  letter-spacing: 0.2px;
  color: ${theme.colors.white};

  @media screen and (max-width: 768px) {
    font-size: ${theme.font.sizes.normal};
  }
`;

export const Subtitle = styled.h3`
  font-size: 18px;
  font-style: normal;
  line-height: 150%;
  letter-spacing: 0.2px;
  color: ${theme.colors.green2};
  font-weight: 700;
`;

export const Circle = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${theme.colors.blue100};
  border-radius: 50%;
  margin-right: 10px;

  font-size: 20px;
  color: ${theme.colors.darkBlue};

  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;
